
export type VisualElementsKey = 
  'headline' | 'actionButton' | 'autoplay' | 'logo' | 'thumbnail' | 
  'pauseOverlay' | 'continueWatching' | 'progressBar' | 'playbackControls' | 
  'audience' | 'border' | 'repeatVideo' | 'affiliate' | 'salesNotification';

export const VisualElements: Record<VisualElementsKey, string> = {
  headline: 'Headline',
  actionButton: 'Action Button',
  autoplay: 'Autoplay',
  logo: 'Logo',
  thumbnail: 'Thumbnail',
  pauseOverlay: 'Pause Overlay',
  continueWatching: 'Continue Watching',
  progressBar: 'Progress Bar',
  playbackControls: 'Playback Controls',
  audience: 'Audience',
  border: 'Border',
  repeatVideo: 'Repeat Video',
  affiliate: 'Affiliate',
  salesNotification: 'Sales Notification'
};
